import { render, staticRenderFns } from "./PluginInstallParamsDrawer.vue?vue&type=template&id=147953c6&scoped=true&"
import script from "./PluginInstallParamsDrawer.vue?vue&type=script&lang=js&"
export * from "./PluginInstallParamsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PluginInstallParamsDrawer.vue?vue&type=style&index=0&id=147953c6&prod&scoped=true&lang=scss&"
import style1 from "./PluginInstallParamsDrawer.vue?vue&type=style&index=1&id=147953c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147953c6",
  null
  
)

export default component.exports